import { MapTo } from "@adobe/aem-react-editable-components";
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager";
import { ReferralStats } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const referralStatsEditConfig = {
    emptyLabel: "ReferralStats",
    isEmpty: (props) => !props.title ||
        !props.referralstatslist ||
        !props.referralstatslist.length ||
        !props.referralhistory ||
        !props.referralhistorylink,
    getProps: (props) => ({
        title: props.title,
        referralstatslist: props.referralstatslist,
        referralhistory: props.referralhistory,
        referralhistorylink: props.referralhistorylink,
        isInEditor: AuthoringUtils.isInEditor().valueOf(),
    }),
};
export default MapTo("loyalty/components/referralstats")(withAemAuthoring(ReferralStats, referralStatsEditConfig));
